import type { ReactNode } from "react";

interface Props {
  title: string;
  reason?: string;
  children: ReactNode;
}

export function Row({ title, reason, children }: Props) {
  return (
    <section className="row">
      <header className="row__head">
        <h2 className="row__title">{title}</h2>
        {reason && <span className="row__reason">{reason}</span>}
      </header>
      <div className="row__track">{children}</div>
    </section>
  );
}
